// import React from 'react'
// import './Connectsection.scss'
// import { Link } from 'lucide-react';
// const SERVICE_TILES = [
//   {
//     id: "/ServicesPage#structured-cabling",
//     title: "Structured Cabling",
//     subtitle: "Reliable voice & data backbone",
//     img: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=800&q=80",
//   },
//   {
//     id: "/ServicesPage#switches",
//     title: "Network Switches",
//     subtitle: "High-performance LAN switching",
//     img: "https://images.unsplash.com/photo-1587202372775-98973d4a04ab?auto=format&fit=crop&w=800&q=80",
//   },
//   {
//     id: "/ServicesPage#servers",
//     title: "Servers",
//     subtitle: "Application & data servers",
//     img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80",
//   },
//   {
//     id: "/ServicesPage#wireless-ap",
//     title: "Wireless Access Point",
//     subtitle: "Secure campus Wi-Fi",
//     img: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=800&q=80",
//   },
//   {
//     id: "/ServicesPage#surveillance-biometric",
//     title: "Surveillance & Biometric",
//     subtitle: "CCTV & access control",
//     img: "https://images.unsplash.com/photo-1580894732444-8ecded7900cd?auto=format&fit=crop&w=800&q=80",
//   },
// ];

// export default function Connectsection() {
//   return (
//     <>
//     <section className="services-hero">
//         <div className="container">
//             <div className="services-hero__grid">
//                 {SERVICE_TILES.map((service) => (
//                     <Link
//                     key={service.id}
//                 to={service.id}
//                 smooth={true}
//                 className="service-tile"
//                     >
//                         <div className="service-tile__image">
//                   <img src={service.img} alt={service.title} loading="lazy" />
//                 </div>
//                 <div className="service-tile__body">
//                   <h2>{service.title}</h2>
//                   <p>{service.subtitle}</p>
//                   <span className="service-tile__cta">View details ▾</span>
//                 </div>
//                     </Link>
//                 ))}

//             </div>
//         </div>
//     </section>
    
//     </>
//   )
// }

import React from "react";
import { useNavigate } from "react-router-dom";
import "./Connectsection.scss";

import camera from '../../../assets/icon/AI-security-camera.png'
import Structure from '../../../assets/icon/Structure Cabling.jpg'
import Access from '../../../assets/icon/Wireless Access Point.jpg'
import server from '../../../assets/icon/server.jpg'
import switc from '../../../assets/icon/switch.jpg'
// import switch from '../../../assets/icon/sw'

const SERVICE_TILES = [
  { id: "structured-cabling", title: "Structured Cabling", img: Structure },
  { id: "switches", title: "Switches", img: switc },
  { id: "servers", title: "Servers", img: server },
  { id: "wireless-ap", title: "Wireless AP", img: Access },
  { id: "surveillance", title: "Surveillance", img: camera },
];

export default function Connectsection() {
  const navigate = useNavigate();

  function handleNavigate(id) {
    navigate(`/ServicesPage#${id}`);
  }

  return (

 <section className="services-hero">
  <div className="services-hero__grid">
    {SERVICE_TILES.map((s) => (
      <div
        key={s.id}
        className="service-card"
        onClick={() => handleNavigate(s.id)}
      >
        <div className="product-card__image">
                        <img src={s.img} alt={s.title} />
                      </div>
        
        <div className="service-card__overlay">
          <h2>{s.title}</h2>
          <p>View details →</p>
        </div>
      </div>
    ))}
  </div>
</section>

  );
}
